@import (reference) '../../../../../constants/spacing.module.less';

.container {
  padding: @space-16 @space-16 @space-0;
}
.details-grid {
  min-height: 110px;
}

.details-column {
  flex: 1;
  min-width: 200px;
  margin-bottom: @space-16;
  margin-right: @space-32;

  &:last-child {
    margin-right: @space-0;
  }
}

.label {
  display: block;
  margin-bottom: @space-12;
}

.value {
  display: block;
  margin-bottom: @space-4;
}

.divider {
  border-color: var(--gray-DFE4E8);
}
